import { PDFDocument, rgb } from "pdf-lib";
import * as fontkit from "fontkit";

export async function personalizePDF(arrayBuffer, name, results) {
  const pdfDoc = await PDFDocument.load(arrayBuffer);
  pdfDoc.registerFontkit(fontkit);

  const arialBytes = await fetch("/ARIALBI.TTF").then(res => {
    if (!res.ok) throw new Error("ARIALBI.TTF not found");
    return res.arrayBuffer();
  });
  const arialBoldBytes = await fetch("/ARIALBD.ttf").then(res => {
    if (!res.ok) throw new Error("ARIALBD.ttf not found");
    return res.arrayBuffer();
  });

  const arialFont = await pdfDoc.embedFont(arialBytes);
  const arialBoldFont = await pdfDoc.embedFont(arialBoldBytes);

  const pages = pdfDoc.getPages();

  const newName = name + ",";
  const firstPage = pages[0];

  firstPage.drawRectangle({
    x: 56,
    y: 415,
    width: 10,
    height: 30,
    color: rgb(1, 1, 1),
  });

  firstPage.drawText(newName, {
    x: 56,
    y: 422,
    size: 16,
    font: arialBoldFont,
    color: rgb(0, 0, 0),
  });

  const resultFontSize = 35;

  const coordinates = [
    { x: pages[1].getWidth() - 75, y: pages[1].getHeight() - 68 },
    { x: pages[2].getWidth() - 62, y: pages[2].getHeight() - 65},
    { x: pages[3].getWidth() - 61, y: pages[3].getHeight() - 64},
    { x: pages[4].getWidth() - 61, y: pages[4].getHeight() - 64},
    { x: pages[5].getWidth() - 60, y: pages[5].getHeight() - 64},
    { x: pages[6].getWidth() - 60, y: pages[6].getHeight() - 64},
  ];

for (let i = 1; i <= 6; i++) {
  const page = pages[i];
  const number = String(results[i - 1]);

  const { x: baseX, y } = coordinates[i - 1];

  const adjustedX = number.length > 1 ? baseX - 10 : baseX;

  page.drawText(number, {
    x: adjustedX,
    y,
    size: resultFontSize,
    font: arialBoldFont,
    color: rgb(1, 1, 1),
  });
}

  const modifiedPdf = await pdfDoc.save();
  return new Blob([modifiedPdf], { type: "application/pdf" });
}
